import { openDB } from 'idb';

const DB_NAME = 'widgetAreaDB';
export const STORE_NAME = 'pinnedApps';

export async function getDB() {
    // return openDB(DB_NAME, 1, {
    //     upgrade(db) {
    //         if (!db.objectStoreNames.contains(STORE_NAME)) {
    //             const store = db.createObjectStore(STORE_NAME, { keyPath: ['peopleId','name'] });
    //             store.createIndex('peopleIndex', 'peopleId', { unique: false });
    //         }
    //     },
    // });

    return openDB(DB_NAME, 3, {
        upgrade(db, oldVersion) {
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                const store = db.createObjectStore(STORE_NAME, {
                    keyPath: ['peopleId', 'name']
                });

                store.createIndex('peopleIndex', 'peopleId', { unique: false });
                store.createIndex('peopleOrderIndex', ['peopleId', 'order'], {
                    unique: false
                });
            }
        }
    });
}

export async function getPinnedApps(peopleId) {
    // const db = await getDB();
    //  const tx = db.transaction(STORE_NAME, 'readonly');
    // const index = tx.objectStore(STORE_NAME).index('peopleIndex');
    // const items = await index.getAll(IDBKeyRange.only(peopleId));
    // await tx.done;
    // return items;

    const db = await getDB();
    const tx = db.transaction(STORE_NAME, 'readonly');
    const index = tx.objectStore(STORE_NAME).index('peopleOrderIndex');

    const items = await index.getAll(
        IDBKeyRange.bound([peopleId, 0], [peopleId, Infinity])
    );

    await tx.done;
    return items;
}

export async function pinApp(destinatonIndex, peopleId, name) {
    const db = await getDB();
    const newItem = {
        peopleId,
        name,
        order: destinatonIndex
    };
    // get last order
    let apps = await getPinnedApps(peopleId);
    apps = apps.filter(app => app.name !== name);
    apps.splice(destinatonIndex, 0, newItem);
    const updatedApps = apps.map((item, index) => ({
        ...item,
        order: index
    })).reverse();
    updatedApps.map((item) =>
        db.put(STORE_NAME, item)

    )
}

export async function unpinApp(peopleId, name) {
    const db = await getDB();
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
     await store.delete([peopleId, name]);

    // re-normalize order
    const items = await getPinnedApps(peopleId);
    const updatedApps = items.map((item, index) => ({
        ...item,
        order: index
    }));
    updatedApps.map((item) =>
        db.put(STORE_NAME, item)
    )
    await tx.done;
}